import { queryClient } from '@/configs/tanstack'
import { api } from '@/utils/api'
import { apiBundlesId } from '@/utils/api/url'
import { useMutation } from '@tanstack/react-query'
import { App } from 'antd'
import { QUERY_KEY_GET_BUNDLES } from './useGetBundles'
import { BundlePayload } from '@/types/bundle'
import { createRouteForAPI } from '@/utils/helpers/urlHelper'
import { useTranslation } from 'react-i18next'
const messageKey = 'update-bundle'

export const useUpdateBundle = () => {
  const { t } = useTranslation('catalog')
  const { message } = App.useApp()
  const mutation = useMutation({
    mutationFn: ({ payload, id }: { payload: BundlePayload; id: string }) =>
      api
        .put(createRouteForAPI(apiBundlesId, { id }), payload)
        .then(({ data }) => data as { message: string }),
    onMutate: () => {
      message.loading({
        key: messageKey,
        content: t('catalog.bundle.updating'),
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_GET_BUNDLES],
      })
      message.success({
        key: messageKey,
        content: t('catalog.bundle.updated'),
      })
    },
    onError: () => {
      message.destroy(messageKey)
    },
  })

  return mutation
}
